/**
 *
 * Search Service Sagas
 *
 */

import { take, call, put } from 'redux-saga/effects';
import moment from 'moment-timezone';
import { DEFAULT_DATE_FORMAT_TIMEZONE, DEFAULT_DATE_TIMEZONE } from 'common';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
import { notAsked, loading, success, failure } from './actions';
import { searchRequest } from './api';
import { SEARCH_REQUEST } from './constants';

export function normalizeResponse(results) {

  if (!isPlainObject(results) || !isArray(results.evaluatedTransfers)) {
    return {};
  }
  const rows = results.evaluatedTransfers.map((row) => {
    const {
      amount,
      initiationTime,
      bankAccount,
    } = row;

    return {
      amount,
      bankAccountNumber: bankAccount ? bankAccount.number : '',
      date: moment.tz(initiationTime, moment.ISO_8601, DEFAULT_DATE_TIMEZONE).format(DEFAULT_DATE_FORMAT_TIMEZONE),
      routingNumber: get(bankAccount, 'identifier.value', ''),
    };
  });
  return rows;
}

export function* requestFlow(apexAccountNumber) {
  // Set the status to LOADING and store the params
  yield put(loading(apexAccountNumber));

  try {
    // Make the request
    const results = yield call(searchRequest, apexAccountNumber);
    // Set the status to SUCCESS and store the results
    yield put(success(normalizeResponse(results)));
  } catch (err) {
    let errorBody = err;
    if (isObject(err.response)) {
      if (isFunction(err.response.json)) {
        errorBody = yield err.response.json();
      }
      errorBody.status = err.response.status;
    } else {
      errorBody = errorBody.toString();
    }
    // The .json() method turns the response body into a promise.
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* recentDepositsFlow() {
  // Set the initial status
  yield put(notAsked());

  while (true) {
    // Watch for SEARCH_REQUEST to be dispatched
    const { apexAccountNumber } = yield take(SEARCH_REQUEST);

    // Make the request
    yield call(requestFlow, apexAccountNumber);

  }
}

export default [recentDepositsFlow()];



// WEBPACK FOOTER //
// ./src/services/recentDeposits/sagas.js